import { render, staticRenderFns } from "./CHANGELOG.md?vue&type=template&id=6ad1c0a0&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CHANGELOG.md"
export default component.exports